import { Box, Link, Tooltip, Typography } from '@mui/material';

import LanguageSelector from '@/components/common/LanguageSelector';
import Copyright from './Copyright';

import './Footer.css';
import { useTranslation } from 'react-i18next';
import i18n from '@/i18n';

function handleClick() {
  const url =
    i18n.language === 'hu'
      ? 'https://www.itrack.hu/hivatalos-dokumentumok'
      : 'https://www.idatatelematics.com/official-documents';

  window.open(url, '_blank', 'noopener,noreferrer');
}

const Footer = ({ showLanguageSelector = false, isPhone }: { showLanguageSelector?: boolean; isPhone: boolean }) => {
  const { t } = useTranslation();
  return (
    <Box className={`login-footer${isPhone ? ' phone' : ''}`}>
      {showLanguageSelector && <LanguageSelector />}
      {isPhone && (
        <Typography
          variant="helperText"
          color="textSecondary"
          lineHeight={1}
          className="login-footer-registration"
          data-qa-element-id="phone_for_registration_label"
        >
          {t('registration.body')}
        </Typography>
      )}
      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="baseline"
        flexWrap="wrap"
        columnGap={1.5}
        rowGap={0.5}
      >
        <Link
          component="button"
          onClick={handleClick}
          data-qa-element-id="login-data-protection-button"
          sx={{
            border: 'none',
            background: 'none',
            padding: 0,
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'baseline',
            flexShrink: 0,
          }}
        >
          <Typography component="span" variant="caption" sx={{ lineHeight: 1 }}>
            {t('login.dataProtection')}
          </Typography>
        </Link>
        <Box display="inline-flex" gap={1} alignItems="baseline" flexShrink={0} sx={{ whiteSpace: 'nowrap' }}>
          <Tooltip title="build ID">
            <Box display="inline-flex" alignItems="baseline" gap={1}>
              <Typography component="span" variant="helperText" sx={{ lineHeight: 1 }}>
                {VERSION}
              </Typography>
              <Typography component="span" variant="helperText" sx={{ lineHeight: 1 }}>
                b{BUILD_NUMBER} ({ENVIRONMENT})
              </Typography>
            </Box>
          </Tooltip>
          <Copyright />
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
